<template>
<div class="honeypot"
  @click="naviagteToHoneymoon()">
  <img src="../assets/honey_pot.png"
    alt="Honeymoon Fund themed Honey Pot">
</div>
</template>

<script>
export default {
  name: 'Honeymoon',
  methods: {
    naviagteToHoneymoon: function () {
      window.open('https://wedding.colaizzo.com/honeymoon');
    }
  }
}
</script>

<style>
.honeypot {
  width: 120px;
  cursor: pointer;
}
</style>
